import React from 'react';
import {Box, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core';
import SwiperCore, {Navigation} from 'swiper';
import {getUrlFile} from '../../../modules/fileHandler';
// import PropTypes from 'prop-types';
import 'swiper/swiper.scss';
import { Button } from 'antd';

SwiperCore.use([Navigation]);


const useStyles = makeStyles((theme) => ({
  customCategory: {
    display: 'flex',
    '& > div': {
      width: '25%',
      display: 'block',
      marginRight: '20px',
      position: 'relative',
      '&::before':{
        content: '""',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: '#E75A29',
        opacity: '40%',
        position: 'absolute',
      },
      '&:last-child': {
        marginRight: 0,
      }
    },
    '& img': {
      width: '100%',
    },
    '& h4': {
      color: 'white',
      fontSize: 18,
      lineHeight: '1.2em'
    },
    '& > div a': {
      background: 'white',
      color: '#E75A29',
      fontWeight: 'bold',
      fontSize: 18,
      borderRadius: 4,
      border: 'none',
      fontFamily: 'comfortaaregular',
      lineHeight: '1.2',
      height: 'auto !important',
      padding: '8px 16px 3px !important',
    },
    '@media (max-width: 600px)' : {
      flexFlow: 'wrap',
      '& > div': {
        width: '100%',
        marginBottom: 20,
        marginRight: '0px',
      },
      '& img': {
        height: 200,
        objectFit: 'cover',
      }
    },
  },
  customConten:{
    position: 'absolute',
    display: 'flex',
    width: '100%',
    textAlign: 'center',
    top: '30%',
    padding: '0px 10px',
    justifyContent: 'flex-end',
    minHeight: 84,
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontSize: 24,
    fontWeight: '900',
    marginBottom: 18,
  },
  swiperCustom: {
    position: 'relative',
    marginTop: theme.spacing(2),
    '& .swiper-button-prev, & .swiper-button-next': {
      position: 'absolute',
      top: 0,
      right: 10,
      width: 40,
      height: 40,
      borderRadius: 500,
      backgroundColor: '#fff',
      boxShadow: '0px 0px 10px 0px rgba(189,189,189,1)',
      '&:after': {
        fontSize: 16,
        textTransform: 'none !important',
        letterSpacing: 0,
        fontVariant: 'initial',
        lineHeight: 1,
      },
    },
  },
  paginationButton: {
    border: `1px solid ${theme.palette.primary.main}`,
    marginRight: theme.spacing(1),
  },
}));

export default function Categories({data, title}) {
  const classes = useStyles();

  if (!data.length) return <div />;
  return (
    <Box component="section">
      <Box display="flex" alignItems="center">
        <Typography className={classes.title} component="h3" variant="subtitle2">
          {title}
        </Typography>
      </Box>
      <div className={classes.customCategory}>
          {data.map((it) => (
            <div>
              <img src={getUrlFile(it.path_cover)} alt={it.name}/>
              <div className={classes.customConten}>
                <h4>{it.name}</h4>
                <Button href={it.slug}>Ver mas</Button>
              </div>
            </div>
          ))}
      </div>
    </Box>
  );
}

Categories.propTypes = {};
